/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserIdsDto } from '../../models/user-ids-dto';
import { UserSearchResultDto } from '../../models/user-search-result-dto';

export interface ListFiltered$Params {
  programId: string;
  body: UserIdsDto;
}

export function listFiltered(
  http: HttpClient,
  rootUrl: string,
  params: ListFiltered$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<UserSearchResultDto>>> {
  const rb = new RequestBuilder(rootUrl, listFiltered.PATH, 'post');
  if (params) {
    rb.path('programId', params.programId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserSearchResultDto>>;
    })
  );
}

listFiltered.PATH = '/users/submitters/programs/{programId}/filterSubmitterUsers';
